import { useMutation, useQueryClient } from '@tanstack/react-query';
import { axios } from '../../config/axios';
import { User } from '../../types/user.types';
import { QUERY_KEYS } from '../../constants/queryKeys.const';

export const useLikeCampaign = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (campaignId: number): Promise<User> =>
      axios.post('users/like', { campaignId }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([QUERY_KEYS.GET_CAMPAIGN]);
        queryClient.invalidateQueries([QUERY_KEYS.GET_WISHLIST]);
      },
    },
  );
};
